import { useEffect, useContext, useState } from "react";
import QlikCard from "components/QlikCard";
import QlikObject from "components/QlikObject";
import GlobalContext from "GlobalContext";


export default function ExpertEvaluationOfProjectsAndPrograms({ title , appDisclaimer , pageTitle, ExportChartFootnote, menuItemsStrings}) {
  useEffect(() => {
    document.title = `${pageTitle} - ${title}`;
  }, [pageTitle,title]);

  const { app } = useContext(GlobalContext);
  const [err, setError] = useState(null);
  const [FilterHeightExpertEvaluation, setFilterHeight] = useState(164);

  useEffect(() => {
    app.model.waitForOpen.promise.then(() => {
      setTimeout(async () => {
        app.model.enigmaModel.evaluate("$(=count({1}distinct [_col_id_eopp_project]))").then(async (reply) => {
          const ExpertEvaluationNumberOfFilterRows = reply*16+36;
          console.log('ExpertEvaluationNumberOfFilterRows/Number of rows: ', ExpertEvaluationNumberOfFilterRows);
          setFilterHeight(ExpertEvaluationNumberOfFilterRows);
        }).catch(err => {
          if(!err) setError(err);
        });
      }, 500);
    });
  }, [app, err])

  return (
    <section className="content">
      <div className="content-header">
        <div className="row mb-2">
          <div className="col-md-10 col-sm-9 col-10">
            <h5 className="page-title"> {title} </h5>
            {/* <h6 className="page-disclaimer"> {appDisclaimer} </h6> */}
          </div>
          {/* <div className="col-md-2 col-sm-3 col-4">
            <QlikObject id="GqNcZ" height="35px" showLoader={false} />
          </div> */}
          <div className="col-md-2 col-sm-3 col-2">
            <QlikObject
              id="f07fb49d-92c2-4727-99f8-f8b415c7191e"
              height="30px"
              showLoader={false}
            />
          </div>
        </div>
      </div>

      <div className="container-fluid">

        <div className="row justify-content-start">

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-10">

              <div className="row justify-content-left">
                {/* Table Row */}

                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* statistics */}
                      <QlikCard
                        id="PfpsAv"
                        height="34px"
                        showHeader={false}
                        showMaximize={false}
                        showExport={false}
                        actionsVisibility="never"
                      />
                    </div>
                  </div>
                  {/* straight table */}
                  <div className="row justify-content-center">
                    <div className="col-12">
                      {/* table */}
                      <QlikCard
                        id="kfRUvB"
                        height="max(calc(100vh - 233px) - 40px, 300px)"
                        showHeader={true}
                        showMaximize={true}
                        showExport={true}
                        onBeforeExportHandler={async ({  }) => {
                            await app.variable.setStringValue('export_link', '1');
                        }}
                        onAfterExportHandler={async ({  }) => {
                            app.variable.setStringValue('export_link', '0');
                        }}
                        exportText = {menuItemsStrings.exportText}
                        exportCompletedText = {menuItemsStrings.exportCompletedText}
                        closeBtnText = {menuItemsStrings.closeBtnText}
                        exportSelectObjectText={menuItemsStrings.exportSelectObjectText}
                        exportNoObjectText={menuItemsStrings.exportNoObjectText}
                        actionsVisibility="always"
                      />
                    </div>
                  </div>

                </div>

              </div>

            </div>

            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-2 col-xl-2 remove-header-spacing">
                  {/* FilterPane */}
                  <QlikCard
                    id="ab41791d-4f0b-438c-8db1-f77673b37dcd"
                    height="56px"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
                  <QlikCard
                    id="bf57758f-b4d3-4370-be9a-598c47b4b840"
                    height={`max(calc((100vh - 233px) - min(calc(10.5vh + 2px), 64px) - 12px - ${FilterHeightExpertEvaluation}px), calc(160px - min(calc(10.5vh + 2px), 64px) - 12px))`}      //- 60px (prior to first -12px)              
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
                  <QlikObject
                    id="VDyQ"
                    height="min(calc(10.5vh + 2px), 64px)"
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />
                  {/* Columns Selector */}
                  <QlikCard
                    id="CQvpJ"
                    height={FilterHeightExpertEvaluation}
                    showHeader={false}
                    showMaximize={false}
                    showExport={false}
                    showOverlayer={false}
                  />

            </div>

          </div>

          <div className="row mb-2">
            <div className="col-md-2 col-sm-3 col-2">
              <QlikObject
                id="sZmBgv"
                height="0px"
                showLoader={false}
              />
            </div>
          </div>
          
        </div>
    </section>
  );
}
